import { Component, OnInit } from '@angular/core';
import {AppConstants} from "../../../shared/constants/app-constant";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-whats-happening',
  templateUrl: './whats-happening.component.html',
  styleUrls: ['./whats-happening.component.scss']
})
export class WhatsHappeningComponent implements OnInit {
    pageTitle: string;
    schools = AppConstants.schools;
    currentPath: string;
    hostelImages = [
        {image_url: './assets/img/hostel-facilities/hostel-image.jpg', name: 'Hostel image'},
        {image_url: './assets/img/hostel-facilities/badminton-court.jpg', name: 'Badminton court'},
        {image_url: './assets/img/hostel-facilities/hostel-view.jpg', name: 'Hostel view'},
        {image_url: './assets/img/hostel-facilities/hostel-view-front.jpg', name: 'Hostel view front'},
    ];
    messImages = [
        {image_url: './assets/img/mess-facilities/mess-image.jpg', name: 'Mess boys'},
        {image_url: './assets/img/mess-facilities/mess-food.jpg', name: 'Mess food'},
        {image_url: './assets/img/mess-facilities/mess-stall.jpg', name: 'Mess stall'},
        {image_url: './assets/img/mess-facilities/mess-boys.jpg', name: 'Mess boys'},
    ];

    transportationImages = [
        {image_url: './assets/img/transportation/aarni-buses.jpg', name: 'Aarni buses'},
        {image_url: './assets/img/transportation/aarni-campus-bus.jpg', name: 'Aarni Campus Bus'},
        {image_url: './assets/img/transportation/aarni-university-bus.jpg', name: 'Aarni University Bus'},
        {image_url: './assets/img/transportation/aarni-university-buses.jpg', name: 'Aarni University Buses'},
    ];

    libraryImages = [
        {image_url: './assets/img/library-images/library-gallery.jpg', name: 'Library gallery'},
        {image_url: './assets/img/library-images/library-group.jpg', name: 'Library group'},
        {image_url: './assets/img/library-images/library-image.jpg', name: 'Library image'},
        {image_url: './assets/img/library-images/library-students.jpg', name: 'Library students'},
    ];

    academicBlockImages = [
        {image_url: './assets/img/academic-blocks/block-a.jpg', name: 'Block A'},
        {image_url: './assets/img/academic-blocks/block-b.jpg', name: 'Block B'},
        {image_url: './assets/img/academic-blocks/block-c.jpg', name: 'Block C'},
        {image_url: './assets/img/academic-blocks/block-d.jpg', name: 'Block D'},
        {image_url: './assets/img/academic-blocks/block-pharmacy.jpg', name: 'Block pharmacy'},
    ];

    sportsFacilitiesImages = [
        {image_url: './assets/img/sports-facilities/badminton.png', name: 'Badminton'},
        {image_url: './assets/img/sports-facilities/volleyball.jpg', name: 'Volleyball'},
        {image_url: './assets/img/sports-facilities/basketball.jpg', name: 'Basketball'},
        {image_url: './assets/img/sports-facilities/tabletennis.jpg', name: 'Table tennis'},
    ];

    gymImages = [
        {image_url: './assets/img/gym-facilities/gym-workout.jpg', name: 'Gym workout'},
        {image_url: './assets/img/gym-facilities/gym-workout-men.jpg', name: 'Gym workout men'},
        {image_url: './assets/img/gym-facilities/running-workout.jpg', name: 'Running workout'},
        {image_url: './assets/img/gym-facilities/weight-lifting.jpg', name: 'Weight lifting'},
    ];

    medicalFacilitiesImages = [
        {image_url: './assets/img/medical-facilities/ambulance.jpg', name: 'Ambulance'},
        {image_url: './assets/img/medical-facilities/blood-donation.jpg', name: 'Blood donation'},
    ];
    auditoriums = [
        {
            id: 1,
            name:  'Aarni Auditorium 1',
            image_url: './assets/img/auditorium-images/auditorium.jpeg',
            description: 'Aarni University’s state-of-the-art auditoriums provide the perfect venue for conferences, seminars, and cultural events, featuring advanced audio-visual technology and comfortable seating. Designed for an immersive experience, the auditoriums ensure clear visibility and acoustics from every seat, fostering an engaging environment for all attendees.',
        },
        {
            id: 2,
            name:  'Aarni Auditorium 2',
            image_url: './assets/img/auditorium-images/auditorium.jpeg',
            description: 'Aarni University’s state-of-the-art auditoriums provide the perfect venue for conferences, seminars, and cultural events, featuring advanced audio-visual technology and comfortable seating. Designed for an immersive experience, the auditoriums ensure clear visibility and acoustics from every seat, fostering an engaging environment for all attendees.',
        }
    ];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.route.data.subscribe(params => {
            if (params && params.title) {
                this.pageTitle = params.title;
            }
        });
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

    ngOnInit(): void {
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    getBackgroundImage(): string {
        switch (this.pageTitle) {
            case 'Infrastructure':
                return "url('./assets/img/internal-banner-campus-life/infrastructure-campus-life.jpg')";
            case 'Academic Facilities':
                return "url('./assets/img/internal-banner-campus-life/academic-facilities-campus-life.jpg')";
            case 'Campus Facilities':
                return "url('./assets/img/internal-banner-campus-life/campus-facilities-campus-life.jpg')";
            case 'Transportation':
                return "url('./assets/img/internal-banner-campus-life/transportation-facilities-campus-life.jpg')";
            case 'Residential Facilities':
                return "url('./assets/img/internal-banner-campus-life/infrastructure-campus-life.jpg')";
            case 'Library':
                return "url('./assets/img/internal-banner-campus-life/library-campus-life.jpg')";
            case 'Schools':
                return "url('./assets/img/internal-banner-campus-life/schools-campus-life.jpg')";
            case 'Green Campus':
                return "url('./assets/img/internal-banner-campus-life/green-campus-campus-life.jpg')";
            case 'NCC':
                return "url('./assets/img/internal-banner-campus-life/ncc-campus-life.jpg')";
            case 'Extra Curricular Activities':
                return "url('./assets/img/internal-banner-campus-life/extra-curricular-activities-campus-life.jpg')";
            case 'Auditorium':
                return "url('./assets/img/internal-banner-campus-life/auditorium-campus-life.jpg')";
            case 'IT Services':
                return "url('./assets/img/internal-banner-campus-life/it-campus-life.jpg')";
            default:
                return "url('./assets/img/internal-banner-campus-life/infrastructure-campus-life.jpg')";
        }
    }

}
